export default __webpack_public_path__ + "static/media/mangeshi temple1.614732b8.jpg";